module.exports = __webpack_public_path__ + "img/no-logo.5f24ced3.jpg";